
// Topmost ancestor of a page, or false when there is nothing to walk up to. A
// level 0 page is a manual section, which is what the rest of the UI treats as a
// page's "main" page. Guarded on every hop, so a parentId pointing at a missing
// doc ends the walk instead of throwing.
export const topLevelPage = (page, allPages) => {
  let current = page;
  while (current && current.parentId && allPages[current.parentId]) {
    current = allPages[current.parentId];
  }
  return current ? current : false;
}

// The same walk, but resolving to the page's key instead of its doc. The docs in
// allPages carry no id field, so top.id off a topLevelPage result is undefined;
// the sluggedPages copy does carry one, because setSluggedPages builds it through
// transformObjectToArray, which synthesizes it from the key. Takes that slugged
// copy rather than a slug so the walk starts from an id it already knows.
export const topLevelPageId = (allPages, sluggedPage) => {
  if (!allPages || !sluggedPage) return false;
  let id = sluggedPage.id;
  let page = allPages[id];
  if (!page) return false;
  while (page.parentId && allPages[page.parentId]) {
    id = page.parentId;
    page = allPages[id];
  }
  return id;
}

export default topLevelPage
